import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Callout } from '../../molecules';
export const CalloutStatementsNone = memo(() => {
    return (_jsx(Callout, { title: "No statements available", message: "Statements will display after your first month of using XBTO products has passed", variant: "secondary", contained: true, small: true }));
});
